module.exports = __webpack_public_path__ + "pcnz/img/bigimg.07de81b4.jpg";